<template>
  <div>
    <v-simple-table>
      <template v-slot:default v-if="items.length">
        <thead>
          <tr>
            <th>Indicador</th>
            <th class="text-center">Tipo Dado</th>
            <th class="text-center">QTD Reali. Mensal</th>
            <th class="text-center">Lançamento</th>
            <th class="text-center">Cadastrado Por</th>
            <th class="text-center">Valor Reali. Mensal</th>
            <th class="text-center">Valor Desc.</th>
            <th class="text-center" v-can-access="24">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id_realizado_equipe">
            <td>{{ `${item.id_indicador} - ${item.indicador}` }}</td>
            <td class="text-center">{{ item.tipo_dado }}</td>
            <td class="text-center">
              <v-icon v-if="item.lanc == 'A'">mdi-robot</v-icon>
              <v-icon v-else>mdi-account-tie</v-icon>
            </td>
            <td class="text-center">{{ item.usuario_cad }}</td>
            <td class="text-center">{{ item.qtde_reali_mensal }}</td>
            <td class="text-center">
              {{ item.valor_reali_mensal | BrazilianCurrency }}
            </td>
            <td class="text-center">
              {{ item.valor_desc | BrazilianCurrency }}
            </td>
            <td class="text-center" v-can-access="24">
              <v-btn
                v-can-access="790"
                icon
                @click="deleteItem(item)"
                class="ml-2"
                color="red"
                dark
                small
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import comissao from "@/services/http/comissaoService";
import currencyMixin from "@/mixins/currencyMixin";
export default {
  props: {
    items: {
      type: Array
    }
  },

  mixins: [currencyMixin],

  data() {
    return {
      dialog: false,
      labelBtn: "Salvar",
      meta: {}
    };
  },

  methods: {
    async deleteRealizadoEquipe(id) {
      try {
        await this.$swal.confirm(
          "Deseja deletar o parâmetro?",
          "Essa ação não pode ser desfeita"
        );
        await comissao()
          .realizadoEquipe(id)
          .delete(null, { notification: true });
        await this.fetchRealizadoEquipes();
      } catch (e) {
        // console.log(e);
      }
    }
  }
};
</script>

<style></style>
